import { useEventListener } from '@nike/privacy-shared-react';
import type { ContextFrameNamesModal } from '@nike/privacy-types';

import { getInlineCustomEventNames } from '../helpers/customEventNames';

/**
 * @name useIsLearnMoreVisibleListener
 * @description - Custom hook which listen event about <LearnMore /> visibility
 * @param {function} handler - Will be run when an event happens
 * @param {ContextFrameNamesModal | undefined} contextFrameName - a namespace to retrieve interactions from
 * @returns {void}
 */
export const useIsLearnMoreVisibleListener = (
  handler: (value: boolean) => void,
  contextFrameName: ContextFrameNamesModal | undefined,
): void => {
  const inlineCookieCustomEventNames = getInlineCustomEventNames(contextFrameName);

  useEventListener(inlineCookieCustomEventNames.LEARN_MORE_IS_SHOWN, () => {
    handler(true);
  });

  useEventListener(inlineCookieCustomEventNames.LEARN_MORE_IS_HIDDEN, () => {
    handler(false);
  });
};
